// src/strapiClient.js
const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "https://cms.viome.com/";
const STRAPI_API_TOKEN =
  process.env.REACT_APP_STRAPI_API_TOKEN ||
  "3c6119c6983ad7319c6995d9ea1b25e3de9fdfae43830ec72013920818b8eae95450dac660bd8a54b863d0d41887a9a6074774e27ace6557de61cc724ad4b9d44991dff0f3a204a816e7e4eb674e0036ad9aa028d36dafe3972c6ee23d83ab879e85b1ecf11994165122bec533580d302991b7ee8a174c8c74728d35290bcdfd";

class StrapiClient {
  constructor() {
    this.baseURL = STRAPI_URL;
    this.apiToken = STRAPI_API_TOKEN;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}api${endpoint}`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.apiToken}`,
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Strapi API request failed:", error);
      throw error;
    }
  }

  // Fetch a single article by IdEntry
  async getArticle(idEntry) {
    return this.request(
      `/articles?filters[IdEntry][$eq]=${idEntry}&populate=*`
    );
  }

  // Fetch article by IdEntry using the exact URL format provided
  async getArticleByExactIdEntry(idEntry) {
    const encodedIdEntry = encodeURIComponent(idEntry);
    return this.request(
      `/articles?filters[IdEntry][%24eq]=${encodedIdEntry}&populate=*`
    );
  }

  // Fetch all articles
  async getArticles() {
    return this.request("/articles?populate=*");
  }

  // Fetch articles with pagination
  async getArticlesWithPagination(page = 1, pageSize = 10) {
    return this.request(
      `/articles?populate=*&pagination[page]=${page}&pagination[pageSize]=${pageSize}`
    );
  }

  // Fetch article by documentId (alternative identifier)
  async getArticleByDocumentId(documentId) {
    return this.request(
      `/articles?filters[documentId][$eq]=${documentId}&populate=*`
    );
  }
}

const strapiClient = new StrapiClient();
export default strapiClient;
